import { IEnumModel } from './../../../../models/enum.model';
import { ManterMatrizPlanejamentoService } from './../../../../services/manter-matriz-planejamento.service';
import { QuestaoFormComponent } from 'src/app/pages/questao-form/questao-form.component';
import {
	Component,
	Input,
	OnInit,
	ViewChild,
	AfterViewInit,
	EventEmitter,
	Output,
	SimpleChanges,
	OnChanges
} from "@angular/core";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IMatrizPlanejamentoQuestaoModel } from 'src/app/models/matriz-planejamento-questao.model';
import { IQuestaoModel } from 'src/app/models/questao.model';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { MatrizPlanejamentoService } from 'src/app/services/matriz-planejamento.service';
import { IMatrizPlanejamentoModel } from 'src/app/models/matriz-planejamento.model';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { QuestaoService } from 'src/app/services/questao.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { IQuestaoConstatacaoModel } from "../../../../models/questao-constatacao.model";
import { IQuestaoProcedimentoAuditoriaModel } from "../../../../models/questao-procedimento-auditoria.model";

@Component({
  selector: 'app-listagem-questoes',
  templateUrl: './listagem-questoes.component.html',
  styleUrls: ['./listagem-questoes.component.scss']
})
export class ListagemQuestoesComponent implements OnInit, AfterViewInit, OnChanges {

	constructor(
		private matDialog: MatDialog,
		private planejamentoService: PlanejamentoService,
		private matrizPlanejamentoService: MatrizPlanejamentoService,
		public router: Router,
		private questaoService: QuestaoService,
		public route: ActivatedRoute) {
		this.tipotrabalhoId = +this.route.snapshot.paramMap.get("id");

		if (this.router.url.includes("planejamento")) {
			this.tipoTrabalho.nome = 'planejamento';
			this.tipoTrabalho.codigo = 7;
			this.isPlanejamento = true;
		} else if (this.router.url.includes("osa")) {
			this.tipoTrabalho.nome = 'osa';
			this.tipoTrabalho.codigo = 4;
			this.isPlanejamento = false;
		}
	}

	@Input() displayedColumns!: string[];
	@Input() subtipoId!: number;
	@Input() planejamentoId!: number;
	@Input() listaDados: IQuestaoModel[] = [] as IQuestaoModel[];
	@Input() matrizPlanejamento!: IMatrizPlanejamentoModel;
	@Input() unidadeGestoraId!: number; // <- ADICIONADO
	@Input() visualizar: boolean;
	@Output() excluirItemEvento: EventEmitter<void> = new EventEmitter<void>();
	@Output() ordemAlterada: EventEmitter<IQuestaoModel[]> = new EventEmitter();


	public isPlanejamento: boolean;
	public tipotrabalhoId: number;
	public tipoTrabalho: IEnumModel = {} as IEnumModel;

	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	public dataSource: MatTableDataSource<IQuestaoModel> = new MatTableDataSource();

	ngOnInit(): void {
		this.filtrarListaPorUnidadeGestora();
	}

	ngAfterViewInit(): void {
		this.dataSource.sort = this.sort;
		this.dataSource.paginator = this.paginator;
		this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.listaDados || changes.unidadeGestoraId) {
			this.filtrarListaPorUnidadeGestora();
		}
	}

	public drop(event: CdkDragDrop<any[]>) {
		moveItemInArray(this.dataSource.data, event.previousIndex, event.currentIndex);
		this.dataSource.data.forEach((item, index) => {
			item.ordem = index + 1;
		});
		this.dataSource._updateChangeSubscription();
		this.ordemAlterada.emit(this.dataSource.data as IQuestaoModel[]);

		const questoesAtualizadas: IQuestaoModel[] = this.dataSource.data.map((item, index): IQuestaoModel => ({
			id: item.id,
			nome: item.nome,
			classificacao: item.classificacao,
			descricao: item.descricao,
			legislacaoAplicavelCriterio: item.legislacaoAplicavelCriterio,
			questaoConstatacao: item.questaoConstatacao as IQuestaoConstatacaoModel[] | number[],
			questaoProcedimentoAuditoria: item.questaoProcedimentoAuditoria as IQuestaoProcedimentoAuditoriaModel[] | number[],
			status: item.status,
			questaoId: item.questaoId,
			ordem: index + 1,
			subTipoAuditoriaId: item.subTipoAuditoriaId,
			ativo: item.ativo,
			avaliar: item.avaliar ?? false,
			tipoTrabalho: item.tipoTrabalho ?? { codigo: 0, nome: '', descricao: '' , guid: ''},
			tipoTrabalhoId: item.tipoTrabalhoId ?? 0,
			value: item.value ?? 0,
			text: item.text ?? '',
			readonly: item.readonly ?? false,
			selecionado: item.selecionado ?? false
		}));
		this.questaoService.atualizarOrdem(questoesAtualizadas).subscribe({
			next: () => {
				console.log('Ordem das questões atualizada com sucesso.');
			},
			error: (error) => {
				console.error('Erro ao atualizar a ordem das questões:', error);
			}
		});

	}

	private filtrarListaPorUnidadeGestora(): void {
		const listaFiltrada = this.listaDados
			?.filter((item: any) => item.unidadeGestoraId === this.unidadeGestoraId && this.planejamentoId === item.planejamentoId)
			.map((item: any) => item.questao)
			.sort((a: any, b: any) => a.ordem - b.ordem) || [];


		this.dataSource = new MatTableDataSource(listaFiltrada);

		if (this.sort && this.paginator) {
			this.dataSource.sort = this.sort;
			this.dataSource.paginator = this.paginator;
		}

		this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
	}

	public modalEditarQuestao(questao: IQuestaoModel, visualizar: Boolean = false) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-listagem-questoes-manter-planejamento';
		dialogConfig.width = '65%';
		dialogConfig.height = '85%';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;

		dialogConfig.data = {
			titulo: visualizar ? 'Editar questão' : 'Visualizar questão',
			data: questao,
			visualizar,
			tipoTrabalho: this.tipoTrabalho,
			tipoTrabalhoId: this.tipotrabalhoId,
			unidadeGestoraId: this.unidadeGestoraId,
			subTipoCategoria: this.matrizPlanejamento.id,
			subTipoAuditoriaId: this.subtipoId,
			planejamentoOrigem: true
		};

		const modal = this.matDialog.open(
			QuestaoFormComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data === 'questao-atualizada') {
				this.excluirItemEvento.next();
			}
		});
	}

	public routeIncludes(tipoTrabalho: string) {
		return this.router.url.includes(tipoTrabalho);
	}

	public sortingDataAccessor = (item: IQuestaoModel, property) => {
		switch (property) {
			case "legislacao":
				return item?.legislacaoAplicavelCriterio;
			case "questao":
				return item?.nome;
			default:
				return item[property];
		}
	};

	public async excluirQuestao(idQuestao: number) {
		Swal.fire({
			title: 'Excluir Registro',
			text: 'Tem certeza que deseja excluir esse registro?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Sim',
			cancelButtonText: 'Não',
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					const response = await this.questaoService.excluir(idQuestao, this.tipoTrabalho?.nome);

					Swal.fire({
						toast: true,
						position: 'top-end',
						icon: response.sucesso ? 'success' : 'warning',
						text: response.mensagem?.descricao || 'Operação concluída.',
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});

					if (response.sucesso) {
						this.dataSource.data = this.dataSource.data.filter((q: any) => q.id !== idQuestao);
						this.dataSource.sort = this.sort;
						this.dataSource.paginator = this.paginator;
						this.excluirItemEvento.next();
					}

				} catch (error) {
					Swal.fire({
						toast: true,
						position: 'top-end',
						icon: 'error',
						text: error?.mensagem?.descricao || 'Erro inesperado ao excluir questão.',
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});
				}
			}
		});
	}
}
